import React from "react";
import PropTypes from "prop-types";

import SecondaryButton from "../Button/SecondaryButton";
import Icon from "../Icon/Icon";

import styles from "./QueryErrorPanel.module.scss";

const QueryErrorPanel = ({
  message = "Something went wrong. Please try again.",
  onRetry,
  className = "",
}) => (
  <div className={`${styles.panel} ${className}`}>
    <p className={styles.message}>{message}</p>
    {onRetry && (
      <SecondaryButton
        type="button"
        onClick={onRetry}
        startIcon={<Icon name="refresh" fontSize="small" />}
      >
        Retry
      </SecondaryButton>
    )}
  </div>
);

QueryErrorPanel.propTypes = {
  message: PropTypes.string,
  onRetry: PropTypes.func,
  className: PropTypes.string,
};

export default QueryErrorPanel;
